/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/fixedSizeChecklist.scss';

import {remToPx} from '@dvrd/dvr-controls';
import React, {CSSProperties, ReactElement} from 'react';
import {FixedSizeList} from 'react-window';
import AutoSizer, { Size } from 'react-virtualized-auto-sizer';

interface Props<T> {
    items: T[];
    renderRow: (item: T, index: number, style: CSSProperties) => ReactElement;
    disabled?: boolean;
    itemSize?: number;
    disabledText?: React.ReactNode;
}

export default function FixedSizeChecklist<T>(props: Props<T>) {
    const {items, disabled, renderRow, disabledText} = props;
    const itemSize = props.itemSize ?? remToPx(2.5);

    function _renderRow(props: { index: any, style: CSSProperties }) {
        const item = items[props.index];
        return renderRow(item, props.index, props.style);
    }

    return (
        <div className='fixed-size-checklist'>
            <AutoSizer>
                {({height, width}: Size) => (
                    <FixedSizeList width={width!} height={height!} itemCount={items.length} itemSize={itemSize}>
                        {_renderRow}
                    </FixedSizeList>
                )}
            </AutoSizer>
            {disabled === true && <div className='overlay'>{disabledText}</div>}
        </div>
    )
}